var _rect, _rect2, _g, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 197,
    viewBox: "0 0 305 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.388916,
    width: 304.513,
    height: 196.056,
    rx: 16,
    fill: "#0054E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1325_134",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 305,
    height: 197
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.388916,
    width: 304.513,
    height: 196.056,
    rx: 16,
    fill: "#0054E6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1325_134)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 265.87,
    cy: 150.47,
    r: 105.179,
    fill: "#0E50C3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.2297,
    cy: 63.4643,
    r: 105.179,
    fill: "#0E50C3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 244.619,
    cy: 168.81,
    r: 11.988,
    fill: "#FCAB7D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.236,
    cy: 168.81,
    r: 11.988,
    fill: "#C33AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.fc1b93682433cfc3ba670fdf60a61140.svg";
export { ForwardRef as ReactComponent };